import StatusLabel from "~/components/StatusLabel";
import {Pagination, Table} from "antd";
import {
	renderDate,
	numberFormat
} from "~/utils";
import {useDevice} from "~/hooks";
import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

function DebtTable({items = [], pagination, onPaginationChange}) {

	const {tableHeight} = useContext(AppContext);

	const {isMobile} = useDevice();

	let columns = [
		{ title: 'Hợp đồng', dataIndex: 'code', key: "code", width: '400px', render: (_, item) => (
				<div>
					<b>{`${item?.code} ${item?.name}`}</b>
					<p>{item?.domain}</p>
					{isMobile &&
						<div>
							<StatusLabel small type={item.status?.badge}>{item.status?.label}</StatusLabel>
							<StatusLabel small type={item.service.badge}>{item.service?.label}</StatusLabel>
							&nbsp;<StatusLabel small type={item.service.badge}>{item.serviceType?.label}</StatusLabel>
							&nbsp;{(item?.package) && <StatusLabel small type={item.service?.badge}>{item?.package}</StatusLabel>}
						</div>
					}
				</div>
			)},
		{ title: 'Phân công', dataIndex: 'user', key: "user", width: '200px', render: (_, item) => (
			<div>
				{item.user?.id && <p>{`${item.user?.firstname} ${item.user?.lastname}`}</p>}
				{item.userShare?.id && <p>{`${item.userShare?.firstname} ${item.userShare?.lastname}`}</p>}
			</div>
		)},
		{ title: 'Ngày ký', dataIndex: 'signing', key: "signing", width: '120px', render: (_, item) => (
			<div><p>{renderDate(item?.signing)}</p></div>
		)},
		{ title: 'Giá trị', dataIndex: 'price', key: "price", width: '180px', render: (_, item) => (
			<p><b>{numberFormat(item?.price)}đ</b></p>
		)},
		{ title: 'Còn lại', dataIndex: 'amountRemaining', key: "amountRemaining", width: '180px', render: (_, item) => (
			<p className="color-grey">{(item?.amountRemaining === 0) ? 'Đã thanh toán' : numberFormat(item?.amountRemaining)}</p>
		)},
		{title: 'Dịch vụ', dataIndex: 'service', key: 'service', render:(_, item) => (
			<div>
				<StatusLabel small type={item.service?.badge}>{item.service?.label}</StatusLabel>
				&nbsp;
				{
					<StatusLabel small type={item.serviceType?.badge}>{item.serviceType?.label}</StatusLabel>
				}
				&nbsp;
				{
					(item?.package) && <StatusLabel small type={item.service?.badge}>{item?.package}</StatusLabel>
				}
			</div>
		)},
	];

	if(isMobile) {
		columns = columns.filter(function (currentValue) {
			return (currentValue.key !== 'customer'
				&& currentValue.key !== 'status'
				&& currentValue.key !== 'service'
			)
		})
	}

	const dataSource= items.map(row => ({
		key: row.id, // I added this line
		...row
	}));

	return (
		<div className="table-wrapper">
			<div className="table-box">
				<Table columns={columns} dataSource={dataSource} scroll={{ y:tableHeight, x: 'max-content' }} pagination={false} />
			</div>
			<Pagination current={pagination.page} defaultCurrent={1} defaultPageSize={20} pageSize={pagination.limit} total={pagination.total} onChange={onPaginationChange}  showSizeChanger={false} />
		</div>
	)
}

export default DebtTable;